import React from 'react';
import { Col, Row } from 'react-bootstrap';

export default function TransactionsPlaceholder(): JSX.Element {
  return (
    <>
      <Row className="pb-2">
        <Col xs="12" sm="6" lg="3" className="placeholder-glow mb-3">
          <div className="placeholder rounded w-100" style={{ height: 36 }} />
        </Col>
        <Col xs="12" sm="6" lg="3" className="placeholder-glow mb-3">
          <div className="placeholder rounded w-100" style={{ height: 36 }} />
        </Col>
        <Col xs="12" sm="6" lg="3" className="placeholder-glow mb-3">
          <div className="placeholder rounded w-100" style={{ height: 36 }} />
        </Col>
        <Col xs="12" sm="6" lg="3" className="placeholder-glow mb-3">
          <div className="placeholder rounded w-100" style={{ height: 36 }} />
        </Col>
      </Row>
      <Row>
        <Col xs="12" className="placeholder-glow mb-3">
          <div className="placeholder rounded w-100" style={{ height: 198 }} />
        </Col>
        <Col xs="12" className="placeholder-glow mb-3">
          <div className="placeholder rounded w-100" style={{ height: 198 }} />
        </Col>
        <Col xs="12" className="placeholder-glow mb-3">
          <div className="placeholder rounded w-100" style={{ height: 198 }} />
        </Col>
        <Col xs="12" className="placeholder-glow mb-3">
          <div className="placeholder rounded w-100" style={{ height: 198 }} />
        </Col>
      </Row>
    </>
  );
}
